import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tries: 0,
  start: null,
};

const slice = createSlice({
  name: 'saturated',
  initialState: initialState,
  reducers: {
    setStart: (state, { payload }) => ({
      ...state,
      start: payload,
      tries: 3,
    }),
    setTries: (state, { payload }) => ({
      ...state,
      tries: payload,
    }),
    restore: () => initialState,
  },
});

export const { setStart, setTries, restore } = slice.actions;

export default slice.reducer;
